import * as React from "react";
import { Grid, Typography } from "@material-ui/core";

import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import Media from "../Media/Media";
import { styles } from "./Summary.style";

type SummaryParagraphType = {
    headline: string;
    text: string;
};

export interface SummaryProps {
    image: string;
    ratio?: "classic" | "pano" | "cinema" | "portrait";
    paragraphs: SummaryParagraphType[];
}

interface SummaryState {
    image: any;
}

class Summary extends React.Component<SummaryProps & WithStyles<typeof styles>, SummaryState> {
    public render() {
        const { classes, image, paragraphs, ratio } = this.props;

        return (
            <div className={classes.container}>
                <Grid className={classes.content} container={true} alignItems="center">
                    <Grid item={true} xs={4}>
                        <Media name={image + "-summary"} ext="jpg" ratio={ratio ? ratio : "classic"} />
                    </Grid>
                    <Grid item={true} xs={8} className={classes.text}>
                        {paragraphs.map((paragraph, index) => (
                            <div key={index}>
                                <Typography variant="subheading" className={classes.headline} component="h3">
                                    {paragraph.headline}
                                </Typography>
                                <Typography component={"p"} dangerouslySetInnerHTML={{ __html: paragraph.text }} />
                            </div>
                        ))}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(Summary);



// WEBPACK FOOTER //
// ./src/components/Summary/Summary.tsx